import React from "react";
import PropTypes from "prop-types";
import { GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { LiveSetupStreamingToolInstallCard } from "./LiveSetupStreamingToolInstallCard";
import { LiveSetupStreamingKeysSetupCard } from "./LiveSetupStreamingKeysSetupCard";

export const LiveSetupCredentialsCards = ({ liveChannel }) => {
  return (
    <GridItem
      gridRow="4"
      gridColumn="1 / span 8"
      marginTop={3}
      style={{ overflowY: "auto", overflowX: "hidden" }}
    >
      <LiveSetupStreamingToolInstallCard />
      <LiveSetupStreamingKeysSetupCard liveChannel={liveChannel} />
    </GridItem>
  );
};

LiveSetupCredentialsCards.propTypes = {
  liveChannel: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    streamKeyValue: PropTypes.string,
    ingestEndpoint: PropTypes.string,
  }),
};

LiveSetupCredentialsCards.defaultProps = {
  liveChannel: {},
};

export default LiveSetupCredentialsCards;
